import { format, parse } from "date-fns";
import { ptBR } from "date-fns/locale";

export function formatNotificationDateTime(date = new Date()) {
  return format(date, "dd/MM/yyyy 'às' HH:mm", { locale: ptBR });
}

export function formatNotificationDateTimePush(date = new Date()) {
  return format(date, "dd/MM 'às' HH:mm", { locale: ptBR });
}

export function formatNotificationCurrency(value: number) {
  return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value);
}

export function truncateNotificationMessage(value: string, max = 100) {
  const normalized = value.trim();
  if (normalized.length <= max) return normalized;
  return `${normalized.slice(0, max)}…`;
}

export function formatSessionRemainder(count: number) {
  return count === 1 ? "1 sessão restante" : `${count} sessões restantes`;
}

export function formatAppointmentDate(value?: string | null) {
  if (!value) return "data não informada";
  const parsed = parse(value, "yyyy-MM-dd", new Date());
  if (Number.isNaN(parsed.getTime())) return "data não informada";
  return format(parsed, "dd/MM/yyyy", { locale: ptBR });
}

export function toNameInitials(name?: string | null) {
  const parts = name?.trim().split(/\s+/).filter(Boolean) ?? [];
  if (parts.length === 0) return "Paciente";
  if (parts.length === 1) return `${parts[0][0]?.toUpperCase()}.`;
  return `${parts[0][0]?.toUpperCase()}. ${parts[parts.length - 1][0]?.toUpperCase()}.`;
}

export function formatNotificationDateTimeShort(date = new Date()) {
  return new Intl.DateTimeFormat("pt-BR", {
    dateStyle: "short",
    timeStyle: "short",
  }).format(date);
}

export function normalizeNotificationLabel(value?: string | null, fallback = "Registro") {
  const normalized = value?.trim();
  return normalized || fallback;
}
